import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  bcpSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import editHardwareAndSchematicsDialog from './dialog.editHardwareAndSchematicsDialog';
import controller from './hardware-and-schematics.controller';
import directive from './hardware-and-schematics.directive';


export default angular.module('app.components.advisory.bcp.hardwareAndSchematics', [
  bcpDataService,
  bcpSharedModelService,
  constants,
  editHardwareAndSchematicsDialog,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('bcpHardwareAndSchematics', directive)
  .controller('HardwareAndSchematicsController', controller)
  .name;

console.log('app.components.advisory.bcp.hardwareAndSchematics created');
